import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';

import { signOut } from '../auth';
import { Modal } from '../modal';
import { Main, Homepage } from '../layout';

import { QUARTER_CONTRAST } from '../theme';

export const mapState = ({ access, serverConfig, isPublic }) => ({
  access,
  serverConfig,
  isPublic,
});

export const Fallback = () => (
  <ErrorMessage>
    Connecting...
    <br />
    <Submessage>
      If you are not connected, please try refreshing the page. Otherwise,
      contact an administrator to request access to this tool.
    </Submessage>
    <br />
    <Submessage onClick={signOut} style={{ cursor: 'pointer' }}>
      Sign Out
    </Submessage>
  </ErrorMessage>
);

export const FullScreen = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const ErrorMessage = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  font-size: 24px;
`;

const Submessage = styled.div`
  width: 100%;
  text-align: center;
  padding: 40px 0;
  font-size: 14px;
  color: ${QUARTER_CONTRAST};
`;

export function AppContainer(props) {
  const { modals, authState } = props;
  const dispatch = useDispatch();
  const { access, serverConfig, isPublic } = useSelector(mapState);

  useEffect(() => {
    if (authState === 'signedIn') dispatch({ type: 'IDENTIFY' });
  });

  if (authState !== 'signedIn' && !isPublic) return null;

  if (serverConfig.namespace === 'homepage' && access) {
    return <Homepage />;
  }

  return (
    <FullScreen>
      {access ? <Main /> : <Fallback />}
      <Modal modals={modals} />
    </FullScreen>
  );
}
